import {useState} from 'react'
import {Switch} from 'antd'

import styles from './RequestApproveForm.module.scss'
import {useCreateProjectConditions} from 'modules/project'
import {Text, Button, Box, Modal} from 'common/components'
import {useOpen} from 'common/hooks'
import {ApprovalConditions, AMLRejectForm, useApproveAML} from '..'

interface AMLApproveFormProps {
  request: any
  aml: any
  onClose: () => void
}

export default function AMLApproveForm({
  request,
  aml,
  onClose,
}: AMLApproveFormProps) {
  const {mutate: approveAML, isMutating: isApproveAMLMutating} = useApproveAML(
    aml.uuid,
    onClose
  )
  const {
    mutate: createProjectConditions,
    isMutating: isCreateProjectConditionsMutating,
  } = useCreateProjectConditions(request.project.uuid, request.uuid, approveAML)
  const [isRejectOpen, handleRejectOpen, handleRejectClose] = useOpen()
  const [isConditions, setIsConditions] = useState(false)
  const [conditions, setConditions] = useState<any[]>([])

  const handleApprove = () => {
    if (isConditions) {
      const newConditions = conditions.map((condition) => ({
        ...condition,
        description: `${aml.name} condition: ${condition.description}`,
      }))
      return createProjectConditions(newConditions)
    }
    approveAML()
  }

  return (
    <>
      <Box mb={24} pt={8}>
        <div className={styles.switch}>
          <Text weight="demiBold">Are there any conditions for approval?</Text>
          <Switch checked={isConditions} onChange={setIsConditions} />
        </div>
      </Box>
      {isConditions && (
        <ApprovalConditions
          noBorrower
          request={request}
          conditions={conditions}
          setConditions={setConditions}
        />
      )}
      <Button
        block
        loading={isApproveAMLMutating || isCreateProjectConditionsMutating}
        disabled={isConditions && !conditions.length}
        onClick={handleApprove}
      >
        Approve aml check
      </Button>
      <Box mt={12}>
        <Text size="xs" color="grey" mb={12}>
          If you believe the person has failed the anti-money-laundering
          verification, you may reject them. In doing so, you must provide a
          justification.
        </Text>
      </Box>
      <Button variant="danger" onClick={handleRejectOpen}>
        reject
      </Button>
      <Modal
        width={486}
        title="AML Reject"
        open={isRejectOpen}
        onCancel={handleRejectClose}
      >
        <AMLRejectForm amlUuid={aml.uuid} onClose={handleRejectClose} />
      </Modal>
    </>
  )
}
